import {TweenMax, Sine} from 'gsap';
const CustomEase = require('gsap/CustomEase');

const preloadBlock = document.querySelector('.preloader');
const preloadProgress = preloadBlock.querySelector('.preloader__bg--progress');
const preloadProgressBar = preloadBlock.querySelector('.preloader [data-progress]');
const Watermark = require('../components/SVGWatermark');
const SizesUtils = require('../../../viscomjs/utils/SizesUtils');
let wm1 = Watermark(preloadBlock.querySelector('.preloader__bg--base'));
let wm2 = Watermark(preloadProgress);
wm1.init();
wm1.start();
wm2.init();
wm2.start();

const preloadState = {
    x: 0,
    progress: 0
};


module.exports.destroy = () => {
	preloadBlock.classList.add('hide');

	TweenMax.to({x: 0}, 1.2, {
        x: -1,
        ease: CustomEase.create('custom', 'M0,0,C0.3,0,0.2,1,1,1'),
        onUpdate: function () {
            const x = this.target.x;
            preloadBlock.style.transform = 'translate3d(' + x * 100 + '%, 0px, 0px)';
            wm1.setLocalShift(x * SizesUtils.winOffsetWidth());
        },
		onComplete: function () {
            wm1.stop();
            wm2.stop();
            if (preloadBlock.parentNode) preloadBlock.parentNode.removeChild(preloadBlock);

            wm1 = null;
            wm2 = null;
        }
    });
};

module.exports.update = loader => {

    if (loader.progress > preloadState.progress) {

        TweenMax.to(preloadState, 1.5 * (loader.progress - preloadState.progress) / 100, {
            x: loader.progress,
            ease: Sine.easeOut,
            onUpdate: function () {
                const x = this.target.x;
                preloadProgress.style.transform = 'translate3d(' + -x + '%, 0px, 0px)';
                preloadProgressBar.style.transform = 'scale(' + x / 100 + ', 1)';
                wm2.setLocalShift(-x * SizesUtils.winOffsetWidth() / 100);
            }
        });

		preloadState.progress = loader.progress;
    }



};



// WEBPACK FOOTER //
// ./js/viscom/boss/soccers/load/Preloader.js